// Distinguishes which surface opened the settings modal, so SettingsModalViewed can attribute the
// visit instead of treating every open as a cold start.
export enum SettingsEntrySource {
  AccountMenu = 'account_menu',
  SidebarSyncFiles = 'sidebar_sync_files',
  MatterOverviewConnectDrive = 'matter_overview_connect_drive',
  DriveViewConnectDrive = 'drive_view_connect_drive',
  MatterSettingsConnectedAccount = 'matter_settings_connected_account',
  FilePickerConnectDms = 'file_picker_connect_dms',
  // Full-page OAuth return (`?external_storage_handoff=` / `?external_storage_error=`). Backend redirects drop
  // React Router location.state, so this is resolved from the query string before the settings
  // route replaces the URL.
  OauthCallback = 'oauth_callback',
  // Typed or bookmarked /dashboard/settings with no location.state and no OAuth query.
  SettingsUrl = 'settings_url',
  // /dashboard/account deep link.
  AccountUrl = 'account_url',
  // Resolver fallback — missing or invalid source.
  Direct = 'direct',
}
